import { Flex } from "../../flex";
import * as RedoTypingCss from "./redo-typing.module.css";

export function RedoTyping({ size = "md" }: { size?: "sm" | "md" }) {
  return (
    <Flex
      className={
        size === "sm"
          ? `${RedoTypingCss.wave} ${RedoTypingCss.waveSmall}`
          : RedoTypingCss.wave
      }
      gap="xs"
      justify="flex-start"
      textAlign="left"
    >
      <span className={RedoTypingCss.dot} />
      <span className={RedoTypingCss.dot} />
      <span className={RedoTypingCss.dot} />
    </Flex>
  );
}
